import { useState, useEffect, useRef } from 'react'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import PeriodizationGeneratorTab from 'components/ProgramGenerator/Periodization/PeriodizationGeneratorTab'
import BasePeriodizationsTab from 'components/ProgramGenerator/Periodization/BasePeriodizationsTab'

export default function ProgramPeriodizationGenerator() {

    const tabs = [
        { name: 'Periodization Generator', key: 'periodization-generator' },
        { name: 'Base Periodizations', key: 'base-periodizations' }
    ]

    const tabRefs = useRef({})
    const containerRef = useRef(null)

    const [highlightStyle, setHighlightStyle] = useState({ width: 0, left: 0 })
    const [selectedTab, setSelectedTab] = useState(tabs[0].key)

    useEffect(() => {
        const updateHighlight = () => {
            const selectedTabRef = tabRefs.current[selectedTab]
            if (selectedTabRef && containerRef.current) {
                const containerRect = containerRef.current.getBoundingClientRect()
                const tabRect = selectedTabRef.getBoundingClientRect()
                const leftOffset = tabRect.left - containerRect.left
                
                setHighlightStyle({
                    width: tabRect.width,
                    left: leftOffset
                })
            }
        }

        // Use requestAnimationFrame to ensure DOM is ready
        const rafId = requestAnimationFrame(() => {
            updateHighlight()
        })

        window.addEventListener('resize', updateHighlight)
        return () => {
            cancelAnimationFrame(rafId)
            window.removeEventListener('resize', updateHighlight)
        }
    }, [selectedTab, tabs])

    return (
        <ScreenFrame limitWidth={false}>
            <div className='flex items-center gap-x-4'>
                <h1 className="text-2xl font-semibold text-gray-900 tracking-tight pt-2 flex-grow">
                    Program Periodization
                </h1>

                <div className='w-fit'>
                    <ContentFrame>
                        <div 
                            ref={containerRef}
                            className='h-12 p-1 flex items-center gap-x-2 relative'
                        >
                            {highlightStyle.width > 0 && (
                                <div
                                    className="absolute border border-orange-500 bg-orange-50 rounded-xl transition-all duration-300 ease-out pointer-events-none"
                                    style={{
                                        width: `${highlightStyle.width}px`,
                                        left: `${highlightStyle.left}px`,
                                        top: '0.375rem',
                                        height: 'calc(100% - 0.75rem)'
                                    }}
                                />
                            )}

                            {tabs.map((tab) => (
                                <div 
                                    key={tab.key}
                                    ref={el => { if (el) tabRefs.current[tab.key] = el }}
                                    className={`
                                        py-1.5 px-4 rounded-xl cursor-pointer relative z-10 text-sm font-medium
                                        ${tab.key === selectedTab ? 'text-orange-600 font-medium' : 'text-gray-700'}
                                        hover:text-orange-600 transition-colors duration-200
                                    `}
                                    onClick={() => setSelectedTab(tab.key)}
                                >
                                    {tab.name}
                                </div>
                            ))}
                        </div>
                    </ContentFrame>
                </div>
            </div>

            {selectedTab === 'periodization-generator' && <PeriodizationGeneratorTab />}

            {selectedTab === 'base-periodizations' && <BasePeriodizationsTab />}

        </ScreenFrame>
    )
}
